// extracted by mini-css-extract-plugin
export default {"tabContent":"ProjectForge_tabContent__oUAdc"};